{
  "close": "Fermer"
}
